export function createTranslator(language, translations) {
  return (key) =>
    translations[language]?.[key] ?? translations.en?.[key] ?? key;
}
